<template>
  <div class="radio-group-wrap">
    <div class="radio-group">
      <div class="label-group">Пол</div>
      <button
        type="button"
        v-for="option in options"
        :key="option.value"
        :class="{ 'selected-button': value === option.value }"
        @click="$emit('input', option.value)">
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    options: Array
  }
};
</script>

<style scoped>
.radio-group {
  display: flex;
  background-color: #f2f2f2;
  justify-content: stretch;
  padding: 6px;
  border-radius: 4px;
  align-items: center;
}
.radio-group .label-group {
  margin-right: 12px;
  background-color: transparent;
  color: #777;
  margin-left: 6px;
  font-weight: 600;
}
.radio-group button {
  background-color: #d4d4d4;
  border-radius: 4px;
  flex: auto;
  color: #474747;
  height: 28px;
  outline: 0;
  font-size: 14px;
}
.radio-group button.selected-button {
  background-color: #bdbdbd;
  color: #222222;
}
.radio-group button {
  margin: 0 3px;
}
.radio-group button:first-child {
  margin-left: 0;
}
.radio-group button:last-child {
  margin-right: 0;
}
</style>